import { IModel } from "@/@types/models/model";
import { coreFields } from "./helpers/coreFields";

const User: IModel = {
  title: "Users",
  apiPath: "admin/users/",
  forms : {
    "login": {
      fields: [
        {source: "username", readonly: false},
        "password"
      ]
    },
    "register" : {
      fields: ["username", "password", "password_confirm", "email", "first_name", "last_name"]
    },
    "insert": {
      fields: ["username", "password", "first_name", "last_name",
        {source: "email", readonly: false}
        , "user_role"]
    },
    "update": {
      fields: ["first_name", "last_name", "username", "user_role", "active",
        {source: "email", readonly: false}]
    },
    "password_reset_request": {
      fields: [ {source: "email", readonly: false } ]
    },
    "password_reset": {
      fields: ["email", "passwordreset_token", "password_new", "password_new_confirm"],
      validator: "validatePasswordReset"
    },
    "password_change": {
      fields: [{source: "password", ttoken: "users.password_current"}, "password_new", "password_new_confirm"],
      validator: "validatePasswordChange"
    },
    "activate": {
      fields: ["email", "activation_token", "password", "password_new", "password_new_confirm"],
      validator: "validatePasswordChange"
    },
    "search": {
      fields: [
        "full_name",
        {source:"email", readonly: false, validation: null},
        {source: "oib", validation: null },
        {source: "status", type:"radio", readonly: false, items: {
          labels: ["users.status_registriran", "users.status_aktivan", "users.status_neaktivan"],
          values: [1, 2, 3]}
        }
      ]
    }
  },
  listViews: {
    "default": {
      fields: ["id", "username", "email", "first_name", "last_name", "user_role", "created_on", "active"]
    },
    "operators": {
      fields: ["id", "username", "email", "first_name", "last_name"],
      hidden: ["id", "email"]
    }
  },
  fields: [
   coreFields.id,
   coreFields.active,
   coreFields.created_on,
    {
      title: "Username",
      source: "username",
      ttoken: "users.username",
      type: "text",
      filter: true,
      validation: {
        required: true,
        maxLength: 50
      }
    },
    {
      title: "Ime",
      source: "first_name",
      ttoken: "users.first_name",
      type: "text",
      filter: true,
      validation: {
        required: true,
        maxLength: 50
      }
    },
    {
      title: "Prezime",
      source: "last_name",
      ttoken: "users.last_name",
      type: "text",
      filter: true,
      validation: {
        required: true,
        maxLength: 50
      }
    },
    {
      title: "Ime i prezime",
      source: "full_name",
      ttoken: "users.full_name",
      type: "text"
    },
    {
      title: "E-mail",
      source: "email",
      ttoken: "users.email",
      type: "text",
      filter: true,
      validation: {
        required: true,
        maxLength: 250,
        regex: "email"
      }
    },
    {
      title: "OIB",
      source: "oib",
      ttoken: "users.oib",
      type: "text",
      validation: {
        required: true,
        minLength: 11,
        maxLength: 11,
        regex: "oib"
      }
    },
    {
      title: "Broj telefona",
      source: "telephone",
      ttoken: "users.telephone",
      type: "text",
      placeholder: "+385xxxxxxxxx",
      validation: {
        required: true,
        maxLength: 15,
        regex: "tel"
      }
    },
    {
      title: "Status",
      source: "status",
      ttoken: "common.status",
      type: "picker",
      readonly: true,
      filter: true,
      items: {
        labels: ["users.status_registriran", "users.status_aktivan", "users.status_neaktivan", "users.status_anoniman"],
        values: [1, 2, 3, 4],
        default: 1
      }
    },
    {
      title: "Uloga",
      source: "uloga",
      ttoken: "users.uloga",
      type: "checkbox",
      items: {
        labels: ["users.uloga_registriranikorisnik", "users.uloga_sluzbenik", "users.uloga_istrazivac", "users.uloga_admin", "users.uloga_adminzahtjevi", "users.uloga_adminsustav"],
        values: [32, 31, 30, 11, 20, 10],
        default: 1
      }
    },
    {
      title: "Napomena",
      source: "napomena",
      ttoken: "users.napomena",
      type: "multiline",
      rows: 2,
      maxRows: 5,
      validation: {
        required: true,
        maxLength: 250
      },
      width: "full"
    },
    {
      title: "Anonimni korisnik",
      source: "is_anoniman",
      ttoken: "users.anoniman",
      readonly: true,
      type: "text",
      items: {
        labels: ["common.ne", "common.da"],
        values: [0, 1],
        default: 0
      }
    },
    {
      title: "Aktivacijski Ključ",
      source: "activation_token",
      ttoken: "users.activation_token",
      type: "text",
      readonly: true,
      validation: {
        required: true,
        maxLength: 50
      }
    },
    {
      title: "Ključ za izmjenu lozinke",
      source: "passwordreset_token",
      ttoken: "users.passwordreset_token",
      type: "text",
      readonly: true,
      validation: {
        required: true,
        maxLength: 50
      }
    },
    {
      title: "Lozinka",
      source: "password",
      ttoken: "users.password",
      type: "password",
      validation: {
        required: true
      }
    },
    {
      title: "Potvrda lozinke",
      source: "password_confirm",
      ttoken: "users.password_confirm",
      type: "password",
      validation: {
        required: true
      }
    },
    {
      title: "Nova lozinka",
      source: "password_new",
      ttoken: "users.password_new",
      type: "password",
      validation: {
        required: true
      }
    },
    {
      title: "Potvrda nove lozinke",
      source: "password_new_confirm",
      ttoken: "users.password_new_confirm",
      type: "password",
      validation: {
        required: true
      }
    },
    {
      title: "anonymize",
      source: "anonymize",
      ttoken: "",
      type: "boolean"
    },
    // {
    //   title: "",
    //   source: "active",
    //   ttoken: "",
    //   type: "checkbox",
    //   items: {
    //     labels: ["users.activate"],
    //     values: [0]
    //   }
    // },
    {
      title: "User Role",
      source: "user_role",
      ttoken: "users.user_role",
      type: "radio",
      row: true,
      validation: {
        required: true
      },
      items: {
        labels: ["user_roles.operater", "user_roles.administrator"],
        values: [80, 90]
      }
    }
  ]
}

export default User;
